module.exports = __webpack_public_path__ + "static/media/c1.3c3a0db7.jpg";